const component = "site-sections-virtualized-table";

export const siteSectionsVirtualizedTable = {
  component,
  table: `${component}/table`,
  tableHeader: `${component}/table-header`,
  sectionCell: {
    cell: `${component}/node-cell`,
    content: `${component}/node-cell/content`,
    toggleSectionIcon: `${component}/node-cell/toggle-section-icon`,
  },
};
